// extracted by mini-css-extract-plugin
module.exports = {"container":"ModifyIcon__container--2fJVN"};